var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-top py-3 mt-1"},[_c('div',{staticClass:"d-flex "},[_c('div',{},[_c('div',{staticClass:"break-white-space mb-2"},[_vm._v(" "+_vm._s(_vm.data.content.Text.Text)+" ")]),_c('div',{staticClass:"panel-bg-file-img mr-1 mb-1 ",style:({
          backgroundImage: 'url(' + _vm.data.content.Image.ImageUrl + ')'
        })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }